import React from 'react';
import Link from 'gatsby-link';
import Icon from 'antd/lib/icon';

const NoKeyPage = (props) =>  {
return(
    <div style={{width: '100%', alignItems: 'center'}}>
        <div style={{padding: '20px 40px 20px 30px', margin: '140px 0px 100px 0px', maxWidth: 600, width: '90%', textAlign: 'center', display: 'inline-block', backgroundColor: 'rgba(0, 0, 0, 0.7)'}}>
            <div style={{
                padding: 40,
                width: '90%',
                display: 'inline-block',
                marginBottom: 100,
            }}>
                <Icon type="warning" style={{fontSize: 50, padding: 20}}/>
                <br/>
                <h3>This email key is used or expired.</h3>
            </div>
        </div>
    </div>
)};

export default NoKeyPage;



// WEBPACK FOOTER //
// ./src/pages/nokey.js